import { ErrorMessage, Field } from "formik";

const Input = ({
  name,
  label,
  id,
  type = "text",
  placeholder = "",
  t,
  ...props
}) => {
  return (
    <div className="flex flex-col">
      {label ? (
        <label htmlFor={id} className={props?.labelClassName}>
          {t(label)}
        </label>
      ) : null}
      <Field
        id={id}
        type={type}
        name={name}
        autoComplete="off"
        placeholder={t(placeholder)}
        className={props?.inputClassName}
        {...props}
      />
      <ErrorMessage
        name={name}
        component="p"
        className="mb-1 text-sm text-warning max-sm:text-xs"
      />
    </div>
  );
};

export default Input;
